import io from 'socket.io-client';
import EventBus from '@/event-bus';
import videojs from "video.js";
import "video.js/dist/video-js.css"
import StreamWebRtc from "@/components/StreamWebRtc.vue"

// Configurar VideoJS globalmente para desactivar logs
// videojs.log.level('error'); // Esta función no existe en esta versión

// Desactivar logs de VideoJS completamente
videojs.log = () => { };
videojs.log.error = () => { };
videojs.log.warn = () => { };
videojs.log.info = () => { };
videojs.log.debug = () => { };

export default {
  name: 'cam',
  components: {
    StreamWebRtc
  },
  props: [
    'id_stream',
    'layout_id',
    'hostname',
    'is_static',
    'show_bar', // analytics / 
    'info_stream',
    'is_analytics',
    'is_channel',
    'layout',
    'layout_end',
    'info_to_component',
    'isNotShowRedirect',
    'isNotShowListAlarms',
  ],


  data: () => ({
    buffer: null,
    mime: 'video/mp4; codecs="avc1.4D0029"',
    mediaSource: new MediaSource(),
    isTypeSupported: false,
    video: true,
    canvas: null,
    coords_multi: true,
    stream: null,
    event_bus: null,
    context: null,
    sizes_draw: {},
    // Variables para throttling basado en requestAnimationFrame
    pendingImageData: null,
    animationFrameId: null,
    isRendering: false,
    // Variables para Intersection Observer
    intersectionObserver: null,
    isVisible: true,
    show: {
      close: false,
      redirect: false,
      list_rois: false,
      alert: false,
      video: false,
      img: true,
      video_media: false,
      iframe: false,
    },
    check_streaming: false, // check if streaming active to render no_video
    status: {
      color: 'secondary',
      message: 'not connected'

    },
    timeout_connection: null,
    list_channels: [
      {
        name: 'motion'
      },
      {
        name: 'basic'
      },
      {
        name: 'face'
      },
      {
        name: 'lpr'
      },
      {
        name: 'hls', // retrans 
      },
      {
        name: 'hls 2', // retrans 
      },
      {
        name: "media",
      },
      {
        name: "WebRTC",
      },
      {
        name: "WebRTC 2",
      },
      {
        name: "WEBRTC-LPR",
      },

    ],
    channel: 'hls', // motion
    clear_draw: null,
    ID_ref: null,
    draw_setting: {
      line_width: 3,
    },
    list_points: [],
    draw_points: [],
    interval_shape: null,
    selected_points: [],
    color_message: 'error',
    message: '',
    recording: {
      active: false,
      color: 'dark',
      interval: null,
    },
    alert: {
      active: false, // tooltip
      color: 'warning',
      message: '',
      message_retrans: '',
      show: false,
    },
    bus: {},
    list_elements: [],
    class_card_text: "pa-0", //  pb-2
    fps_sreaming: null,
    draw_option: ["default", "skeleton"],
    draw_option_sels: [0, 1],
    list_option_draws: [
      {
        name: "default",
        key: "default",
        action: "select_draw"
      },
      {
        name: "skeleton",
        key: "skeleton",
        action: "select_draw"
      },
    ],
    video_setup: {
      "liveui": true,
      autoplay: true,
      controls: true,
      fluid: true,
      preload: 'auto',
      // width     : "100%",
      // height    : "100%",
      // Desactivar logs de VideoJS completamente
      logLevel: 'error', // Solo mostrar errores críticos
      html5: {
        hls: {
          smoothQualityChange: true,
          enableLowInitialPlaylist: true,
          overrideNative: true,
        }
      },
      hls: {
        smoothQualityChange: true,
        enableLowInitialPlaylist: true,
        // smoothQualityChange: true,
        overrideNative: true,
      },
      // Configuración adicional para silenciar logs
      suppressNotSupportedError: true,
      sources: [
        {
          src: '/path/to/video.mp4',
          type: "application/x-mpegURL", //
        },
        {
          src: '/path/to/video.mp4',
          type: "application/x-mpegURL", //
        }
      ]
    },
    video_source: "",
    video_type: "application/x-mpegURL",
    player: null,
    video_listening: null,
    media_buffer: null,
    link_iframe: "",
    timers: [],
    eventListeners: [], // Array para trackear todos los event listeners
    busListeners: {}, // Objeto para trackear los event listeners del EventBus
    bufferCleanupInterval: null,
    maxBufferSize: 5, // 20 minutos en segundos
    defaultBufferSize: 5,
    lprBufferSize: 5, // 5 minutos en segundos para LPR
    // PTZ Control
    ptz: {
      enabled: false,
      loading: false,
      speed: { x: 0.5, y: 0.5, z: 0.3 },
      speedLevel: 'medium', // slow, medium, fast
      position: { x: 0, y: 0, z: 0 },
      status: null,
      isMoving: false, // Flag para rastrear si hay movimiento activo
      isStopping: false, // Flag para evitar múltiples requests de stop simultáneos
      stopTimer: null, // Timer para debounce del stop
      visible: false, // Flag para mostrar/ocultar controles PTZ
    },
  }), // data

  created() {
    let vm = this;
    if (this.is_analytics) {
      this.ID_ref = this.is_analytics;
    } else {
      if (this.layout_id) {
        this.ID_ref = this.layout_id
      }
    }
    let is_temp_chanel = false;
    if (this.is_channel) {
      is_temp_chanel = true;
      this.channel = this.is_channel;
    }

    // Verificar si el dispositivo es PTZ (verificación inicial por propiedades)
    if (this.info_stream && (this.info_stream.isPTZ || this.info_stream.ptz || this.info_stream.type === 'PTZ')) {
      this.ptz.enabled = true;
    }

    this.set_stream(this.id_stream);

    // Verificar dinámicamente si el dispositivo es PTZ mediante request ONVIF
    this.checkPtzCapability();

    if (this.$route && this.$route.name && (this.$route.name.includes('dashboard') || this.$route.name.includes('streaming'))) {
      this.show.close = true;
      this.show.redirect = true;
      this.show.list_rois = true;
      if (!this.$Helper.current_auth_user(this.currentUser, { roles: [1, 2] })) {
        this.show.redirect = false;
        this.show.list_rois = false;
        this.show.close = false;

      }
      if (this.$route.name.includes("dashboard")) {
        let modul = this.$store.getters["auth/permission"]("dashboard");
        if (!modul.can_edit) {
          this.show.redirect = false;
          this.show.list_rois = false;

        }
        if (!modul.can_delete) {
          this.show.close = false;
        }
      }
      if (this.isNotShowRedirect) {
        this.show.redirect = false;
      }
      if (this.isNotShowListAlarms) {
        this.show.list_rois = false;
      }


    }

    if (this.$route.name == 'setting_device') {
      this.show.redirect = false;
    }
    this.render_channel(this.channel, is_temp_chanel);


    /*if (this.info_stream && this.info_stream.is_record) {
      this.start_recording();
    }*/

    // setting parameters line and color draws
    if (localStorage.getItem('streaming_paramaters')) {
      const info_get = JSON.parse(localStorage.getItem('streaming_paramaters'));
      if (info_get) {
        this.draw_setting = info_get;
      }
    }
    let temp_dev = this.$SmartEvent.get(this.id_stream, "list_points");
    if (temp_dev) {
      this.list_points = temp_dev;
    }
    else {

      temp_dev = this.$Helper.get_local('alarms');
      if (temp_dev && temp_dev.length > 0) {
        let search_id = this.id_stream;

        temp_dev.forEach((alarm) => {

          if (alarm.Detail_device_alarm && alarm.Detail_device_alarm.length > 0) {

            const find = (alarm.Detail_device_alarm).some((dev) => {
              if (dev.deviceId == search_id) {
                if (dev.detail_roi_device && dev.detail_roi_device.length > 0) {
                  dev.detail_roi_device.forEach((roi, idx_roi) => {
                    try {

                      vm.list_points.push({
                        name: "Area " + alarm.name + " " + idx_roi + 1,
                        point: JSON.parse(roi.points),
                        active: false,
                      });
                    } catch (e) {
                      console.log("error converto to json roi : ", e);
                    }
                  })
                }
                return true
              }
            })
          }
        })
      } // alarms


    } //  list points
    if (this.info_to_component) {
      if (this.info_to_component.list_points_ids) {
        this.render_list_ids_selected(this.info_to_component.list_points_ids);
      }

      if (this.info_to_component.list_no_show_bar && this.info_to_component.list_no_show_bar.length > 0) {
        this.info_to_component.list_no_show_bar.forEach((sw) => {
          this.show[sw] = false;
        })
      }
    }
  }, // created

  watch: {
    id_stream: function (vl) {
      this.set_stream(vl);

    }, // id stream

    layout: function (val) {
      if (val) {
        const temp_resized = this.draw_setting && this.draw_setting.resized_continue ? this.draw_setting.resized_continue : true;
        if (temp_resized) {
          this.update_shape();
        }
      }
    }, // layout

    layout_end: function (val) {
      const temp_resized = this.draw_setting && this.draw_setting.resized_continue ? this.draw_setting.resized_continue : false;
      if (temp_resized) {
        this.update_shape();
        this.$emit('resized_state', false);
      }
    },// layout end

  }, // watch

  computed: {

    render_draw_points: function () {
      return this.draw_points;
    },  // draw points

    currentUser() {
      return this.$store.state.auth.user;
    }, // currentUser

  }, // computed

  methods: {

    // Extraer información de conexión desde RTSP
    extractConnFromRtsp(url) {
      if (!url || typeof url !== 'string') return null;
      try {
        const re = new RegExp("^rtsp:\\/\\/(?:([^:@\\/]+)(?::([^@\\/]*))?@)?\\[?([^\\/:\\]]+)\\]?(?::(\\d+))?");
        const m = re.exec(url);
        if (!m) return null;
        const username = m[1] || '';
        const password = m[2] || '';
        const host = m[3] || '';
        const rtspPort = m[4] ? parseInt(m[4], 10) : null;
        // Para ONVIF asumimos HTTP 80 si no se conoce otro
        const port = 80;
        const secure = false;
        return { username, password, host, port, secure };
      } catch (e) { return null; }
    }, // extract connection from rtsp

    // Obtener objeto de conexión para PTZ
    getPtzConnection() {
      if (!this.info_stream || !this.info_stream.rtsp) return null;
      const conn = this.extractConnFromRtsp(this.info_stream.rtsp);
      if (!conn || !conn.host) return null;
      return {
        hostname: conn.host,
        port: conn.port,
        secure: conn.secure,
        username: conn.username,
        password: conn.password,
      };
    }, // get ptz connection

    // Verificar si el dispositivo tiene capacidades PTZ
    async checkPtzCapability() {
      try {
        // Solo verificar si es una cámara IP (no periféricos)
        if (!this.info_stream || !this.info_stream.rtsp || this.info_stream.type === 'PERIPHERAL') {
          return;
        }

        const connection = this.getPtzConnection();
        if (!connection) {
          return;
        }

        const api = this.$URL + '/api/v1/onvif/ptz/status';
        const res = await this.$axios.post(api, { connection });

        // Si el request es exitoso, el dispositivo tiene capacidades PTZ
        if (res && res.data) {
          this.ptz.enabled = true;
          this.ptz.status = res.data;
          if (res.data.position) {
            this.ptz.position = res.data.position;
          }
          console.log('PTZ capability detected for device:', this.id_stream);
        }
      } catch (e) {
        // Si falla, el dispositivo probablemente no tiene capacidades PTZ
        // No es un error crítico, solo significa que no es PTZ
        if (e.response && e.response.status !== 404) {
          console.debug('PTZ capability check failed (device may not support PTZ):', e.message);
        }
      }
    }, // check ptz capability

    // PTZ Status
    async ptzStatus() {
      try {
        const connection = this.getPtzConnection();
        if (!connection) {
          console.warn('No PTZ connection available');
          return;
        }
        this.ptz.loading = true;
        const api = this.$URL + '/api/v1/onvif/ptz/status';
        const res = await this.$axios.post(api, { connection });
        if (res && res.data) {
          this.ptz.status = res.data;
          if (res.data.position) {
            this.ptz.position = res.data.position;
          }
        }
      } catch (e) {
        console.error('PTZ Status Error:', e);
      } finally {
        this.ptz.loading = false;
      }
    }, // ptz status

    // PTZ Continuous Movement
    async ptzContinuous(speed, timeoutSec = 1) {
      try {
        this.ptz.loading = true;
        const connection = this.getPtzConnection();
        if (!connection) {
          console.warn('No PTZ connection available');
          this.ptz.loading = false;
          return;
        }
        const api = this.$URL + '/api/v1/onvif/ptz/continuous';
        const rtsp = this.info_stream && this.info_stream.rtsp ? this.info_stream.rtsp : '';
        const body = {
          connection,
          Velocity: speed || this.ptz.speed || { x: 0, y: 0, z: 0 },
          Timeout: timeoutSec || 1,
          rtsp: rtsp,
        };
        await this.$axios.post(api, body);
      } catch (e) {
        console.error('PTZ Continuous Error:', e);
      } finally {
        this.ptz.loading = false;
      }
    }, // ptz continuous

    // PTZ Relative Movement
    async ptzRelative(translation, speed = null) {
      try {
        this.ptz.loading = true;
        const connection = this.getPtzConnection();
        if (!connection) {
          console.warn('No PTZ connection available');
          this.ptz.loading = false;
          return;
        }
        const api = this.$URL + '/api/v1/onvif/ptz/relative';
        const body = {
          connection,
          translation,
        };
        if (speed) {
          body.speed = speed;
        }
        await this.$axios.post(api, body);
      } catch (e) {
        console.error('PTZ Relative Error:', e);
      } finally {
        this.ptz.loading = false;
      }
    }, // ptz relative

    // PTZ Absolute Movement
    async ptzAbsolute(position, speed = null) {
      try {
        this.ptz.loading = true;
        const connection = this.getPtzConnection();
        if (!connection) {
          console.warn('No PTZ connection available');
          this.ptz.loading = false;
          return;
        }
        const api = this.$URL + '/api/v1/onvif/ptz/absolute';
        const body = {
          connection,
          position,
        };
        if (speed) {
          body.speed = speed;
        }
        await this.$axios.post(api, body);
      } catch (e) {
        console.error('PTZ Absolute Error:', e);
      } finally {
        this.ptz.loading = false;
      }
    }, // ptz absolute

    // PTZ Stop (llamado desde mouseup/mouseleave - solo actualiza estado local)
    async ptzStop(panTilt = true, zoom = true) {
      // Solo actualizar el estado local, no enviar request al servidor
      if (this.ptz.isMoving) {
        this.ptz.isMoving = false;
      }
    }, // ptz stop

    // PTZ Stop Button (llamado desde el botón de stop - envía request al servidor)
    async ptzStopButton() {
      try {
        this.ptz.loading = true;
        const connection = this.getPtzConnection();
        if (!connection) {
          console.warn('No PTZ connection available');
          this.ptz.isMoving = false;
          this.ptz.loading = false;
          return;
        }
        const api = this.$URL + '/api/v1/onvif/ptz/stop';
        const rtsp = this.info_stream && this.info_stream.rtsp ? this.info_stream.rtsp : '';
        const body = {
          connection,
          pan_tilt: true,
          zoom: true,
          rtsp: rtsp,
        };
        await this.$axios.post(api, body);
        // Marcar que el movimiento ha terminado
        this.ptz.isMoving = false;
      } catch (e) {
        console.error('PTZ Stop Error:', e);
        this.ptz.isMoving = false;
      } finally {
        this.ptz.loading = false;
      }
    }, // ptz stop button

    // Obtener velocidad según nivel
    getPtzSpeed() {
      const speeds = {
        slow: { x: 0.2, y: 0.2, z: 0.1 },
        medium: { x: 0.5, y: 0.5, z: 0.3 },
        fast: { x: 0.8, y: 0.8, z: 0.5 },
      };
      return speeds[this.ptz.speedLevel] || speeds.medium;
    }, // get ptz speed

    // Controladores PTZ - Pan/Tilt
    ptzMove(direction) {
      // Marcar que hay movimiento activo
      this.ptz.isMoving = true;
      const speedConfig = this.getPtzSpeed();
      let speed = { x: 0, y: 0, z: 0 };
      switch (direction) {
        case 'left':
          speed.x = -speedConfig.x;
          break;
        case 'right':
          speed.x = speedConfig.x;
          break;
        case 'up':
          speed.y = speedConfig.y;
          break;
        case 'down':
          speed.y = -speedConfig.y;
          break;
        case 'up-left':
          speed.x = -speedConfig.x;
          speed.y = speedConfig.y;
          break;
        case 'up-right':
          speed.x = speedConfig.x;
          speed.y = speedConfig.y;
          break;
        case 'down-left':
          speed.x = -speedConfig.x;
          speed.y = -speedConfig.y;
          break;
        case 'down-right':
          speed.x = speedConfig.x;
          speed.y = -speedConfig.y;
          break;
      }
      this.ptzContinuous(speed, 1);
    }, // ptz move

    // PTZ Home/Reset Position
    ptzHome() {
      // Mover a posición central (0, 0, 0)
      this.ptzAbsolute({ x: 0, y: 0, z: 0 }, this.getPtzSpeed());
    }, // ptz home

    // Controladores PTZ - Zoom
    ptzZoom(direction) {
      // Marcar que hay movimiento activo
      this.ptz.isMoving = true;
      const speedConfig = this.getPtzSpeed();
      let speed = { x: 0, y: 0, z: 0 };
      if (direction === 'in') {
        speed.z = speedConfig.z;
      } else if (direction === 'out') {
        speed.z = -speedConfig.z;
      }
      this.ptzContinuous(speed, 1);
    }, // ptz zoom

    set_stream(val) {
      // set for no video
      this.render_no_video(false);
      this.stream = this.id_stream;
      if (val == 'new_device') {
        this.channel = 'basic';
      }


      if (val) {
        // this.$forceUpdate();
        this.render_bus();

      } else {
        // this.stream = 'Streaming';

        this.render_no_video(false);
        EventBus.$on('res_new_device', this.bus.res_new_device = (action) => {
          if (action) {
            this.render_no_video(true, true, true);
          }

        })
        // this.$destroy();
      }

    }, // set stream

    actions(act, item, opt) {
      if (act == 'select_draw') {
        if (this.draw_option.includes(item.key)) {

          this.draw_option.splice(this.draw_option.findIndex(x => (x == item.key)), 1);
        } else {
          this.draw_option.push(item.key);
        }
        if (this.draw_option && this.draw_option.length == 0) {
          this.draw_option = [this.$ml.get('none_selected')]
        }
      }
    }, // actions

    render_channel(val, def = false) {
      this.channel = val;
      if (!def) {
        this.$emit('update_of_component', {
          component: 'cam_test',
          key: 'channel',
          value: val,
          ID: this.layout_id,
        });
      }
      this.render_no_video(true, true, true);
      this.show.img = false;
      this.show.video = false;
      this.show.media = false;
      this.show.iframe = false;


      if (this.player) {
        this.player.dispose();
        this.video_listening = null;
        this.player = null;

      }
      if (this.media_buffer) {
        this.clear_media_buffer();
      }

      if (val == 'basic') {
        this.show.img = true;
        let rtsp = null,
          deviceId = '';
        if (this.info_stream && this.info_stream.rtsp) {
          rtsp = this.info_stream.rtsp;
          deviceId = this.stream;
        } else {
          console.warn("no found rtsp")
        }
        if (rtsp) {
          EventBus.$emit('add_new_device', {
            rtsp: rtsp,
            deviceId
          })
        }
      } else
        if (val && val.includes("hls")) {
          this.show.video = true;

          /*if (this.info_stream.hls) {
            this.video_setup.sources[0].src = this.info_stream.hls;
          }*/
          let temp = val.split(" ");
          try {

            if (temp && temp.length > 1) {
              this.video_setup.sources[0].src = this.$Format.format_local_hls({ ...this.info_stream }, "hls", 2);
              this.video_setup.sources[1].src = this.video_setup.sources[0].src;

            } else {
              this.video_setup.sources[0].src = this.$Format.format_local_hls({ ...this.info_stream }, "hls");
              this.video_setup.sources[1].src = this.video_setup.sources[0].src;
            }

          } catch (er) {
            // console.warn("Error set hls ", this.layout_id , er)
          }
          this.$nextTick(() => {

            // let video             =   document.getElementById('video' + this.stream + this.ID_ref);
            let parent = document.getElementById('content' + this.stream + this.ID_ref);
            let video = document.createElement("video");
            video.id = 'video' + this.stream + this.ID_ref;
            video.className = "video-js";
            video.preload = "auto";
            video.controls = "true";
            video.style.width = "100%";
            video.style.height = "100%";
            video.setAttribute("playsinline", "true");
            // Append new video element to parent element
            parent.appendChild(video);
            // Initialize video.js and Nuevo plugin
            /* video.addEventListener("error", (event) => {
               console.log("TARGET ERROR ============== ", event.target.error.message);
             })*/

            // console.log("check video js ", video)
            this.player = videojs(video, this.video_setup, this.video_listening = () => {
              // Desactivar logs de VideoJS
              this.player.log = () => { }; // Desactivar logs

              // Desactivar logs de error específicos
              this.player.on('error', () => {
                // Solo loggear errores críticos, no errores de red
                const error = this.player.error();
                if (error && error.code !== 4) { // 4 = MEDIA_ERR_SRC_NOT_SUPPORTED
                  console.warn("VideoJS Error:", error);
                }
              });

              // Desactivar logs de retryplaylist
              this.player.tech(true).on('retryplaylist', (event) => {
                // Silenciar logs de retryplaylist
              });

            }); // videojs
          }); // nextTick   

        } else if (val == "media") {
          this.show.video_media = true;
          this.$nextTick(() => {

            this.mediaSourceTest();
          })
        } else if (val == "WebRTC") {
          this.show.iframe = true;
          const formate_webRTC = this.$Format.format_local_webRTC({ ...this.info_stream }, 'WebRTC', 1);
          if (formate_webRTC) {
            this.link_iframe = formate_webRTC;
          }

        } else if (val == "WebRTC 2") {
          this.show.iframe = true;
          const formate_webRTC = this.$Format.format_local_webRTC({ ...this.info_stream }, 'WebRTC', 2);
          if (formate_webRTC) {
            this.link_iframe = formate_webRTC;
          }
        } else if (val == "WEBRTC-LPR") {
          this.show.iframe = true;
          const formate_webRTC = this.$Format.format_local_webRTC({ ...this.info_stream }, 'local', 'WEBRTC-LPR');
          if (formate_webRTC) {
            this.link_iframe = formate_webRTC;
          }
        }
        else {
          this.show.img = true;
          this.video_pause();
        }

      // Ajustar el tamaño del buffer según el canal
      if (val === 'lpr') {
        this.maxBufferSize = this.lprBufferSize;
      } else {
        this.maxBufferSize = this.defaultBufferSize;
      }
    }, // render channel
    video_pause() {
      if (this.player) {
        this.player.pause();
      }
    }, // video pause

    play() {
      if (this.player) {
        this.player.play();
      }
    },

    render_alert(item, save = true) {
      let vm = this;
      if (item) {
        if (item.color_tag == "error") {
          vm.alert.show = true;
          vm.alert.active = true;
          if (save) { this.save_state_device(item); }
          const timer_alert = setTimeout(() => {
            vm.alert.active = false;
            clearTimeout(timer_alert);
          }, 3500)
        } else if (item.color_tag == "success") {
          if (save) { this.save_state_device(item); }
        }
        if (item.color_tag != "error") {
          vm.alert.show = false;
        }

        if (item.detail) {
          if (item.module == 'ping') {
            vm.alert.message = item.detail;
            vm.status.ping = item.detail;
            item.color_tag == "error" ? vm.start_recording(false) : vm.start_recording(true);
          }
          if (item.module == 'retransmission') {
            vm.alert.message_retrans = item.detail;
            vm.status.retransmission = item.detail;
          }
        }
        /*if (item.code) {
          if (vm.$ml.get(item.code)) {
            vm.alert.message = vm.$ml.get(item.code);
          }
        }*/

      } else {
        console.warn("Not value item  alert in cam : ", item)
      }
    }, // render_alert

    render_list_ids_selected(item) {
      if (item && item.length > 0) {
        this.$nextTick(() => {
          if (this.list_points && this.list_points.length > 0) {
            this.list_points.forEach((point, idx_point) => {
              if (item.includes(point.ID)) {
                this.selected_points.push(idx_point);
                this.render_shape(point.point, point, idx_point, true);
              }
            })
          }
        })
      }
    }, // render_list_ids_selected

    save_state_device(item) {
      if (item) {

        let temp = this.$Helper.get_local("state_devices")
        if (temp) {
          temp[item.deviceId] = { ...item };
        } else {
          temp = {};
          temp['deviceId'] = { ...item };
        }
        this.$Helper.set_local("state_devices", temp);
      }
    }, // save state device

    streaming_buffer: function (buffer) {
      let vm = this;
      let id = this.stream;
      vm.canvas = document.getElementById('stream' + id);
      const view = new Uint8Array(buffer);
      const out = new Uint8ClampedArray(4 * 640 * 480);
      const size = Math.sqrt(view.length);
      if (size % 1) {
        console.error('not a square');
        return;
      }
      view.forEach((a, i) => out[(i * 4) + 3] = a);
      const image = new ImageData(out, 640, 480)
      vm.canvas.getContext('2d').putImageData(image, 0, 0);

      // Liberar memoria explícitamente
      view = null;
      out = null;
      image = null;
    },
    streaming_buffer_img: function (input) {
      let vm = this;
      let id = this.stream;
      var blob = new Blob([input], { type: 'image/png' });
      var url = URL.createObjectURL(blob);
      // console.log(url)
      var img = document.getElementById('img' + id)

      img.onload = function () {
        URL.revokeObjectURL(url);
      }
      img.src = url;
      blob = null;
      url = null;
      img = null;
    }, // streaming buffer img

    start_recording(state = true) {
      let vm = this;
      if (state) {
        if (!vm.recording.interval) {
          vm.recording.interval = setInterval(() => {
            if (vm.recording.color == 'error') {
              vm.recording.color = 'dark';
            } else {
              vm.recording.color = 'error';
            }
          }, 1500)
        }
      } else {
        vm.recording.color = 'dark';
        if (vm.recording.interval) {
          clearInterval(vm.recording.interval);
          vm.recording.interval = null;
        }
      }
    }, // start recording

    addEventListener(element, event, handler) {
      if (element instanceof HTMLElement) {
        element.addEventListener(event, handler);
        this.eventListeners.push({ element, event, handler });
      } else if (element === EventBus) {
        // Para EventBus usamos $on
        element.$on(event, handler);
        this.busListeners[event] = handler;
      }
    },

    removeAllEventListeners() {
      // Limpiar event listeners de DOM
      this.eventListeners.forEach(({ element, event, handler }) => {
        if (element instanceof HTMLElement) {
          element.removeEventListener(event, handler);
        }
      });
      this.eventListeners = [];

      // Limpiar event listeners del EventBus
      for (let event in this.busListeners) {
        EventBus.$off(event, this.busListeners[event]);
      }
      this.busListeners = {};
    },

    render_bus() {
      // for not start stream
      if (!this.is_static) {
        if (!this.channel.includes("hls") || !this.channel.includes("media")) {
          EventBus.$emit('start_stream', this.stream, this.hostname);
        }
      }


      if (this.event_bus) {
        EventBus.$off(this.event_bus, this.bus[this.event_bus]);
        this.event_bus = null;
      }
      let vm = this;

      let isload = false;
      let temp_time = 1;

      this.$nextTick(() => {

        // container div 
        let content = document.getElementById('content' + this.stream + this.ID_ref);

        // image background
        let img = document.getElementById('img' + this.stream + this.ID_ref);

        // canvas draw
        let roi = document.getElementById('drawData' + this.stream + this.ID_ref);
        let context_roi = null;

        // Verificar que los elementos DOM existen
        if (!content) {
          console.warn('Content element not found for stream:', this.stream);
          return;
        }

        if (!img) {
          console.warn('Image element not found for stream:', this.stream);
          return;
        }

        if (!roi) {
          console.warn('ROI element not found for stream:', this.stream);
          return;
        }

        let streaming = document.getElementById('stream' + this.stream + this.ID_ref);


        // let context_streaming =   streaming.getContext('2d');
        let check, current_width, current_height;
        if (img) {

          check = this.check_height();
          current_width = roi.width = img.getBoundingClientRect().width
          current_height = roi.height = this.check_height() - 18;//img.getBoundingClientRect().height;

          /*this.video_setup.width  = current_width + 'px';
          this.video_setup.height = current_height + 'px';*/

          context_roi = roi.getContext('2d');
          this.list_elements.push(content, img, roi);

          this.context = context_roi;
          this.sizes_draw = {
            w: current_width,
            h: current_height,
          }
          if (current_height === 0) {
            const timer_height = setTimeout(() => {
              current_height = roi.height = 90; // this.$refs.card_cam.$el.clientHeight;
              img.style.height = content.style.height = current_height + 'px';
              vm.context = context_roi;
            }, 3000);
          }
        }
        let sw = false;
        let time = 0;
        let temp_bus = 'stream' + this.stream;
        this.event_bus = temp_bus;
        // EventBus.$on(temp_bus, this.bus[temp_bus] =
        /*this.$WS.set_workspace({
          workspace_ : this.stream,
          key        : this.stream,
        });*/

        // this.$WS.channel(this.stream,"stream", 
        const streamHandler = (msg) => {
          if (!this.check_streaming) {
            if (this.timeout_connection) { clearTimeout(this.timeout_connection) };

            this.check_streaming = true;
            this.render_no_video(true, true, true);
            // }, 8000);
            /*this.status = {
              message: this.$ml.get('no_receiving_stream'),
              color: 'warning',
            }*/

          }

          if (msg.channel == this.channel) {
            // Verificar que img existe antes de procesar
            if (!img) {
              console.warn('Image element not found, skipping stream processing');
              return;
            }

            // Usar throttling basado en requestAnimationFrame
            if (msg.timestamp > time) {
              time = msg.timestamp;
              // Programar el renderizado para el siguiente frame
              this.scheduleImageRender({ msg, img, time });
            } else if (!msg.timestamp) {
              // Programar el renderizado para el siguiente frame
              this.scheduleImageRender({ msg, img, time });
            }
          }
        };
        this.addEventListener(EventBus, temp_bus, streamHandler);
        this.bus[temp_bus] = streamHandler;
        let is_recording = false
        let temp_rec = 'recording' + this.stream;
        EventBus.$on(temp_rec, this.bus[temp_rec] = (msg) => {


          if (!is_recording && msg) {
            vm.recording.active = true;
            is_recording = true;
            vm.start_recording();
          } else {
            if (!msg) {
              is_recording = false;
              vm.recording.active = false;
              vm.start_recording(false)
            }
          }

        });
        let temp_status_rec = 'status_recording' + this.stream;
        EventBus.$on(temp_status_rec, this.bus[temp_status_rec] = (msg) => {
          vm.render_alert(msg);
        });


        /* HEAD
                if (msg && msg.analytics_results && msg.analytics_results[0].length>0 && msg.analytics_results[0] && msg.analytics_results[0].bbox) {
                  let box = msg.analytics_results[0].bbox;
                  let exs = msg;
        */

        let temp_status_stream = 'status_stream' + this.stream;
        EventBus.$on(temp_status_stream, this.bus[temp_status_stream] = (stats) => {
          this.status = stats;
        });
        // ************************* Bus Objects - Draw analytics ***************************************


        let line_width = vm.draw_setting && vm.draw_setting.parameters && vm.draw_setting.parameters.line_width ? parseInt(vm.draw_setting.parameters.line_width) : 2;
        let draw_colors = vm.draw_setting && vm.draw_setting.list && vm.draw_setting.list.length > 0 ? vm.draw_setting.list : null;


        let temp_width, temp_height;
        let temp_event = 'event_stream' + this.stream;
        EventBus.$on(temp_event, this.bus[temp_event] = (msg) => {


          if (msg && msg.analytics_results && msg.analytics_results.length > 0 && msg.analytics_results[0] && (msg.analytics_results[0].bbox || vm.draw_option.includes('skeleton')) && img) {

            if (vm.clear_draw) {
              clearTimeout(vm.clear_draw);
              vm.clear_draw = null;
            }

            // Verificar que roi existe antes de procesar
            if (!roi) {
              //console.warn('ROI element not found, skipping analytics processing');
              return;
            }

            // let box = msg.analytics_results[0].bbox;
            let exs = msg;

            current_width = roi.width = img.getBoundingClientRect().width;
            current_height = roi.height = check - 18//img.getBoundingClientRect().height;

            /*let xn = box.x - (box.w/2);
            let yn = box.y - (box.h/2);*/


            context_roi.clearRect(0, 0, current_width, current_height);


            // Verificar que roi.width y roi.height existen antes de calcular los factores
            let factorx = roi.width ? (roi.width / 320) : 1;
            let factory = roi.height ? (roi.height / 240) : 1;

            if (exs.analytics_results && exs.analytics_results.length > 0) {
              let aux = {};
              exs.analytics_results.forEach(function (element, index, array) {
                // Verificar que context_roi existe antes de usarlo
                if (!context_roi) {
                  console.warn('Context ROI not available, skipping element processing');
                  return;
                }

                let color_set = '';
                if (draw_colors && draw_colors.length > 0 && element.tag) {
                  const find_color = draw_colors.some((tag_color => {
                    if (tag_color.tag == element.tag) {
                      color_set = tag_color.color;
                      return true;
                    }
                  }))
                }
                if (!color_set) {
                  vm.set_color_context(context_roi);
                } else {
                  context_roi.strokeStyle = color_set;
                }
                context_roi.lineWidth = line_width;
                if (vm.draw_option.includes("skeleton")) {
                  if (element.points && element.points.length > 0) {
                    vm.draw_skeleton_streaming(element.points, context_roi, current_width, current_height)
                  }
                }
                if (element.bbox && vm.draw_option.includes("default")) {
                  let fx = element.bbox.x * parseInt(current_width);
                  let fy = element.bbox.y * parseInt(current_height);
                  let w = element.bbox.w * parseInt(current_width);
                  let h = element.bbox.h * parseInt(current_width);
                  fx = Math.abs(fx);
                  fy = Math.abs(fy);
                  context_roi.strokeRect(fx, fy, w, h);
                  context_roi.font = "12px Georgia";
                  context_roi.fillStyle = "rgba(0,0,0,1)";
                  context_roi.fillText(element.tag, fx + 20, fy + 20);
                  aux = {
                    x: fx * parseInt(current_width),
                    y: fy * parseInt(current_height),
                    w: element.bbox.w * parseInt(current_width),
                    h: element.bbox.h * parseInt(current_width)
                  }
                }
              }); // forEach

              // Verificar que context_roi existe antes de configurar el timeout
              if (context_roi) {
                vm.clear_draw = setTimeout(() => {
                  if (context_roi && current_width && current_height) {
                    context_roi.clearRect(0, 0, current_width, current_height);
                  }
                  clearTimeout(vm.clear_draw);
                }, 5000);
              }
            }

          }
        }) // Event Stream

        // Liberar referencias locales después de configurar los event listeners
        content = null;
        roi = null;
        streaming = null;
        context_roi = null;
        draw_colors = null;

      }) // nextTick

      // init event bus action for no video
      let states = {};
      if (vm.info_stream && vm.info_stream.container && vm.info_stream.container.length > 0) {

        vm.info_stream.container.forEach((cont) => {
          states[cont.idContainer] = {
            analytic: cont.type,
            state: true,
          };
        })
      }
      let temp_status_cont = 'status_container' + this.stream;
      EventBus.$on(temp_status_cont, this.bus[temp_status_cont] = (action) => {
        if (action && states[action.idContainer]) {
          states[action.idContainer].state = action.state;
          if (states[action.idContainer].state) {
            if (vm.channel == states[action.idContainer].analytic) {

              this.render_no_video(true, true, true);
            }
          } else {
            if (vm.channel == states[action.idContainer].analytic) {
              this.render_no_video()
            }
          }
        } else {
          console.log("Not found container ", action);
        }
      });

    }, // render bus


    draw_skeleton_streaming(points, context_roi, current_width, current_height) {
      // Verificar que todos los parámetros son válidos
      if (!points || !Array.isArray(points) || points.length === 0) {
        console.warn('Invalid points array for skeleton drawing');
        return;
      }

      if (!context_roi) {
        console.warn('Context ROI not available for skeleton drawing');
        return;
      }

      if (!current_width || !current_height) {
        console.warn('Invalid dimensions for skeleton drawing');
        return;
      }

      if (points && points.length > 0) {

        const { x, y } = points.shift();
        // if (x && y) {

        context_roi.beginPath();
        context_roi.arc(parseFloat(x) * current_width, parseFloat(y) * current_height, 8, 0, Math.PI * 2, 1);
        context_roi.fill();
        this.draw_skeleton_streaming(points, context_roi, current_width, current_height)
      }

    }, // draw skeleton streaming

    test_skeleton() {
      let content = document.getElementById('content' + this.stream + this.ID_ref);
      let img = document.getElementById('img' + this.stream + this.ID_ref);
      let roi = document.getElementById('drawData' + this.stream + this.ID_ref);

      // Verificar que los elementos DOM existen
      if (!content || !img || !roi) {
        console.warn('Required DOM elements not found for test_skeleton');
        return;
      }

      let context_roi = roi.getContext('2d');
      let check = this.check_height();

      // Verificar que el contexto se obtuvo correctamente
      if (!context_roi) {
        console.warn('Could not get 2D context for ROI element');
        return;
      }

      // image background
      let current_width, current_height;
      current_width = roi.width = img.getBoundingClientRect().width;
      current_height = roi.height = check - 18
      if (context_roi) {

        this.set_color_context(context_roi);
        let list = [{

          points: [
            { point: 1, x: '0.275522', y: '0.143697' },
            { point: 2, x: '0.284499', y: '0.127108' },
            { point: 4, x: '0.308123', y: '0.133387' },
            { point: 7, x: '0.276817', y: '0.206865' },
            { point: 9, x: '0.227278', y: '0.270406' },
            { point: 11, x: '0.144526', y: '0.297103' },
            { point: 18, x: '0.303080', y: '0.215302' }
            /*{
              point : 1,
              x : 0.12,
              y : 0.23,
            },
            {
              point : 2,
              x : 0.15,
              y : 0.45,
            },{
              point : 3,
              x : 0.14,
              y : 0.4610,
            },{
              point : 4,
              x : 0.35,
              y : 0.15,
            },
            {
              point : 5,
              x : 0.20,
              y : 0.25,
            }*/
          ]
        }
        ];
        let dx, dy;
        list[0].points.forEach((p) => {
          setTimeout(() => {

            dx = p.x;
            dy = p.y;
            // context_roi.clearRect(0, 0, current_width, current_height );
            /* context_roi.beginPath();
             context_roi.moveTo(dx,dy);
             context_roi.lineTo(180 + dx,180 + dy);
             context_roi.stroke()*/
            context_roi.beginPath();
            context_roi.arc(dx * current_width, dy * current_height, 5, 0, Math.PI * 2, 1);
            context_roi.fill();
          }, 1000)
        })
      } else {
        console.warn("No get context to draw ");
      }
    },
    set_color_context(context) {
      let o = Math.round, r = Math.random, s = 255;
      let ca = 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + r().toFixed(1) + ',0.5)';
      let num1 = o(r() * s)
      let num2 = o(r() * s)
      let num3 = o(r() * s)
      context.strokeStyle = 'rgba(' + num1 + ',' + num2 + ',' + num3 + ',0.5)';//'#ffffff';
      context.fillStyle = 'rgba(' + num1 + ',' + num2 + ',' + num3 + ',0.5)';//'#00ff00';
      return context.strokeStyle;
      // context.lineWidth   = 10;
    },

    render_no_video(is_streaming = false, connection = false, status = false) {
      if (!this.context) {
        // El contexto aún no está listo, sal de la función para evitar errores
        return;
      }
      this.$nextTick(() => {
        let image = document.getElementById('img' + this.stream + this.ID_ref);
        const { w, h } = this.sizes_draw;
        if (image) {

          if (is_streaming) {
            // this.show_video=true;
            image.style.width = "100%";
            image.style.height = "100%";//95
            image.style.padding = "0px";
            image.style.align = "none";

            if (connection) {
              let text = "CONNECTING ..."
              this.context.font = "20px Georgia";
              this.context.fillStyle = "white";//"rgba(255,255,255, 0.9)";
              // this.context.texAlign = "start"
              if (text) {
                this.context.fillText(text, this.sizes_draw.w / 2.3, this.sizes_draw.h / 2, [this.sizes_draw.w]);
              }

              if (!status) {
                if (this.timer_status) { clearTimeout(this.timer_status) };
                this.timer_status = setTimeout(() => {

                  text = "NO CONNECTED"
                  this.context.clearRect(0, 0, w, h);
                  this.context.fillText(text, this.sizes_draw.w / 2.3, this.sizes_draw.h / 2, [this.sizes_draw.w]);
                  // const time_stream = setTimeout(()=>{
                  // if (sw_stream == true) {
                  this.status = {
                    message: this.$ml.get('no_receiving_stream'),
                    color: 'warning',
                  }
                  // }
                  // clearTimeout(time_stream)
                }, 5000)
              } else { // status
                if (this.timeout_connection) { clearTimeout(this.timeout_connection) };
                if (this.timer_status) { clearTimeout(this.timer_status) };
                this.context.clearRect(0, 0, w, h);
                this.status = {
                  message: this.$ml.get('connected'),
                  color: 'success',
                }
              }

            }// connections
            else { //!connection

              // console.log("No connection with cam : ", this.stream);
            } // !conection
          } else {
            // !is_streaming
            // this.show_video=false;

            image.style.width = "100%";
            image.style.height = "100%";
            image.style.objectFit = "fill";
            image.src = this.$logos.no_signal;
            this.check_streaming = false;
            this.timeout_connection = setTimeout(() => {

              if (this.ID_ref && this.ID_ref === 0) {
                image.style.padding = "10px"
                image.style.width = "100%";
                image.style.height = "100%";
              } else {
                image.style.padding = "100px"
                image.style.width = "100%";
                image.style.height = "100%";
              }


              image.style.align = "center";
              // image.style.justifyContent="center";
              image.style.margin = "auto";
              /*image.style.marginLeft = "auto";
              image.style.marginRight = "auto";*/
              image.style.display = "block";

              image.src = this.$logos.mark ? this.$logos.mark :
                this.$vuetify.theme.dark ? this.$logos.login_night : this.$logos.login;//"/img/logos/LogoLoginNight.png";

              this.status = {
                message: this.$ml.get('no_receiving_stream'),
                color: 'warning',
              }

              clearTimeout(this.timeout_connection);

            }, 5000)

          }
        } else {
          // console.log('Property null html')
        }
      })

    }, // render no video

    redirect() {
      let inf_setting = this.info_stream;
      localStorage.setItem('settings_device', JSON.stringify({ inf_setting }));
      EventBus.$emit('redirect_view', 'setting_device');

      // }
    }, // redirect

    render_shape(point, item, idx, is_saved = false) {
      let vm = this;
      let key = item.name
      let list = this.selected_points,
        idx_point = null,
        find = false;

      if (!is_saved) {

        let info_up = { ... this.info_to_component };


        if (info_up.list_points_ids && info_up.list_points_ids.length > 0) {
          if (info_up.list_points_ids && info_up.list_points_ids.length > 0 && info_up.list_points_ids.includes(item.ID)) {
            info_up.list_points_ids.splice(info_up.list_points_ids.indexOf(item.ID), 1);
          } else {

            info_up.list_points_ids.push(item.ID);
          }
        } else {
          info_up.list_points_ids = [];
          info_up.list_points_ids.push(item.ID);
        }




        // console.log("************** CAM REGISTER POINT IN LOCAL ", info_up)
        this.$emit("update_of_component", {
          component: "cam_test",
          value: info_up,
          ID: this.layout_id,
        })
      }




      // its finded won't render, 
      const find_point = vm.draw_points.some((sel2, idx_sel2) => {
        if (sel2.name == key) {
          idx_point = idx_sel2;
          return true;
        }
      });

      // if finded its select else unselect
      vm.list_points[idx].active = !vm.list_points[idx].active;
      find = vm.list_points[idx].active;

      // console.log("Render : sel", key, find , " list point: ",find_point)

      if (point && find && !find_point) {
        // if (point.point1 || point.point2) { 


        let len = vm.draw_points && vm.draw_points.length > 0 ? vm.draw_points.length + 1 : 1;

        vm.draw_points.push({
          id: len,
          name: key,
          polygon: [],
          context: null,
        })
        let points = typeof point == 'string' ? point : point && point.points ? point.points : point;

        try {

          if (typeof points === 'string') {
            points = JSON.parse(points);
            if (typeof points === 'string') {
              points = JSON.parse(points)
              if (typeof points === 'string') {
                points = JSON.parse(points)
              }
            }
          }

        } catch (er) {
          console.log("Error convert to json cam ", er);
        }
        // check point
        if (points && points.width) {
          this.color_message = 'error';
          this.message = 'Not have area of interest';
          const timer_msg = setTimeout(() => {
            vm.message = '';
            clearTimeout(timer_msg)
          }, 2000)
        }

        // console.log(point, typeof point," *********************+ POINT ", vm.draw_points, len, points);

        this.$nextTick(() => {
          let info_point = document.getElementById('drawPoint' + this.stream + this.ID_ref + len);
          let img = document.getElementById('img' + this.stream + this.ID_ref);
          let draw_point = null;
          this.list_elements.push(info_point);

          if (info_point && info_point.getContext("2d") && img) {
            // Sincronizar tamaño del canvas con la imagen de fondo
            const w = img.getBoundingClientRect().width;
            const h = img.getBoundingClientRect().height;
            info_point.width = w;
            info_point.height = h;
            info_point.style.width = w + 'px';
            info_point.style.height = h + 'px';

            draw_point = info_point.getContext("2d");
            let nodeRadius = 5; // width cirle point

            // Normalizamos a array [[x,y], ...] con coords 0-1 para que
            // update_shape pueda re-escalar ante cambios de layout (fix blur F5).
            let polygon_norm = [];
            if (Array.isArray(points)) {
              points.forEach(pt => {
                if (
                  Array.isArray(pt) &&
                  pt.length === 2 &&
                  !isNaN(pt[0]) && !isNaN(pt[1])
                ) {
                  polygon_norm.push([parseFloat(pt[0]), parseFloat(pt[1])]);
                }
              });
            } else if (typeof points === 'object' && points !== null) {
              Object.keys(points)
                .filter(k => k.startsWith('point'))
                .sort()
                .forEach(k => {
                  const pt = points[k];
                  if (Array.isArray(pt) && pt.length === 2 && !isNaN(pt[0]) && !isNaN(pt[1])) {
                    polygon_norm.push([parseFloat(pt[0]), parseFloat(pt[1])]);
                  }
                });
            }
            let polygon = polygon_norm.map(([x, y]) => [x * w, y * h]);
            const textOffsetY = idx * 28;
            vm.drawPolygon(draw_point, polygon, nodeRadius, info_point, item.name, textOffsetY);
            vm.draw_points[len - 1].polygon = polygon_norm;
            vm.draw_points[len - 1].context = draw_point;
            vm.draw_points[len - 1].nodeRadius = nodeRadius;
            vm.draw_points[len - 1].info_point = info_point;
            polygon = null;
            polygon_norm = null;
            points = null;
          } else {
            console.log("[render_shape] No se puede obtener el contexto 2D del canvas para el ROI", { info_point });
          }
        }); // nextTick

        // }

      } else {
        const { w, h } = this.sizes_draw
        if (!find && find_point) {
          // console.log("index point ", idx_point, vm.draw_points[idx_point])
          if (vm.draw_points && vm.draw_points[idx_point]) {
            vm.draw_points[idx_point].context.clearRect(0, 0, w, h);
            // Elimina el objeto del array para permitir volver a pintar correctamente
            vm.draw_points.splice(idx_point, 1);
          }
        }
        if (find && find_point) {
          console.log("update_shape");
          this.update_shape(idx_point);
        }
      } // render

    }, // render shape

    update_shape(idx = null) {
      let list_shapes = this.draw_points,
        item = {},
        vm = this;

      let img = document.getElementById('img' + this.stream + this.ID_ref);
      let check = this.check_height();
      item.width = img.getBoundingClientRect().width;
      item.height = Math.abs(check - 18); //img.getBoundingClientRect().height - 
      this.update_elements();
      // console.log( "heigth diff ", item.height , check, check - item.height);

      // console.log("update : ",idx)
      if (idx != 0 || idx == null) {

        list_shapes.forEach((shape, idx) => {
          // console.log("update polygon : ", shape)
          if (shape.polygon && shape.polygon.length > 0 && shape.info_point && img) {
            // Sincronizar tamaño del canvas con la imagen de fondo
            const w = img.getBoundingClientRect().width;
            const h = img.getBoundingClientRect().height;
            shape.info_point.width = w;
            shape.info_point.height = h;
            shape.info_point.style.width = w + 'px';
            shape.info_point.style.height = h + 'px';
            shape.context.clearRect(0, 0, w, h);
            let polygon = [], points = shape.polygon;
            for (let point_ in points) {
              polygon.push([
                parseFloat(points[point_][0]) * w,
                parseFloat(points[point_][1]) * h
              ]);
            }

            const textOffsetY = idx * 28; // 28px de separación (más grande)
            vm.drawPolygon(shape.context, polygon, shape.nodeRadius, { width: w, height: h }, shape.name, textOffsetY);
          }
        });
      } else {
        let shape = list_shapes[idx];
        // console.log(shape , "update shape 2")
        if (shape.polygon) {

          // Ajustar tamaño real del canvas para evitar borrosidad
          shape.info_point.width = shape.info_point.offsetWidth;
          shape.info_point.height = shape.info_point.offsetHeight;
          let item_width = shape.info_point.width;
          let item_height = shape.info_point.height;
          shape.context.clearRect(0, 0, item_width, item_height);
          let polygon = [], points = shape.polygon;
          for (let point_ in points) {
            polygon.push([
              parseFloat(points[point_][0]) * item_width,
              parseFloat(points[point_][1]) * item_height
            ]);
          }

          vm.drawPolygon(shape.context, polygon, shape.nodeRadius, { width: item_width, height: item_height }, shape.name);
        }
      }

    }, // update shape

    drawPolygon(ctx, poly, nodeRadius, roi, name = null, textOffsetY = 0) {
      ctx.lineWidth = 2; // line width 4
      let o = Math.round, r = Math.random, s = 255;
      let num1 = o(r() * s)
      let num2 = o(r() * s)
      let num3 = o(r() * s)
      let color_set = 'rgba(' + num1 + ',' + num2 + ',' + num3 + ',0.9)'; // más opaco para texto
      // color stroke / fill 
      ctx.strokeStyle = color_set;
      ctx.fillStyle = 'rgba(' + num1 + ',' + num2 + ',' + num3 + ',0.3)';

      ctx.beginPath();
      let x, y;
      for (let index in poly) {
        x = poly[index][0];
        y = poly[index][1];
        ctx.lineTo(x, y);
      }
      ctx.closePath();
      ctx.stroke();
      ctx.fill();

      // Dibuja los nodos
      for (let index in poly) {
        x = poly[index][0];
        y = poly[index][1];
        ctx.beginPath();
        ctx.arc(x, y, nodeRadius, 0, Math.PI * 2, 1);
        ctx.fill();
      }

      // Mostrar el nombre del área o SmartEvent en el centroide, desplazado y resaltado
      if (name) {
        let cx = 0, cy = 0;
        for (let i = 0; i < poly.length; i++) {
          cx += poly[i][0];
          cy += poly[i][1];
        }
        cx = cx / poly.length;
        cy = cy / poly.length;
        ctx.font = "bold 14px Arial";
        // Fondo semitransparente para el texto
        const textWidth = ctx.measureText(name).width;
        ctx.fillStyle = "rgba(0,0,0,0.5)";
        ctx.fillRect(cx - 2, cy - 22 + textOffsetY, textWidth + 4, 18);
        // Texto con borde negro y color del rectángulo
        ctx.fillStyle = color_set;
        ctx.strokeStyle = "#000";
        ctx.lineWidth = 2;
        ctx.strokeText(name, cx, cy - 10 + textOffsetY);
        ctx.fillText(name, cx, cy - 10 + textOffsetY);
      }
    }, // drawPolygon

    check_height() {
      let h = this.$refs;
      // console.log("check height : ------------------------> ", h , h['height' + this.layout_id].$el.clientHeight) ;
      if (h && h['height' + this.layout_id] && h['height' + this.layout_id].$el && h['height' + this.layout_id].$el.clientHeight) {
        return h['height' + this.layout_id].$el.clientHeight;
      }
    }, // check heigth

    update_elements(h_element) {
      h_element = h_element ? h_element : this.check_height() - 23;
      let vm = this;
      if (vm.list_elements && vm.list_elements.length > 0) {

        vm.list_elements.forEach((el) => {
          if (el) {
            el.style.height = h_element + 'px';
            // console.log("element : ", el)
          }
        });
      }
    },


    mediaSourceTest() {
      let mime = 'video/mp4; codecs="avc1.4D0029"';
      let vm = this;
      if (!MediaSource.isTypeSupported(mime)) {
        alert('Unsupported mime type');
        return;
      }

      // Limpiar recursos anteriores si existen
      if (vm.media_buffer) {
        this.clear_media_buffer();
      }

      vm.media_buffer = {};
      vm.media_buffer.Buffer = {};
      let video = document.getElementById('video_media' + vm.stream + vm.ID_ref);

      // Guardar referencia al URL para limpiarlo después
      vm.media_buffer.mediaSource = new MediaSource();
      vm.media_buffer.videoUrl = URL.createObjectURL(vm.media_buffer.mediaSource);
      video.src = vm.media_buffer.videoUrl;

      vm.media_buffer.list_media = ["error_listener", "sourceopen_listener"];
      vm.media_buffer.list_buffer = ["updateend_listener"];

      // Usar addEventListener para elementos DOM
      vm.media_buffer.error_listener = function (e) {
        console.log('error: ' + vm.media_buffer.mediaSource.readyState);
      };
      vm.media_buffer.mediaSource.addEventListener('error', vm.media_buffer.error_listener);

      vm.media_buffer.sourceopen_listener = function (e) {
        const { protocol_socket, ip, port_socket } = vm.$API;
        const url = `${protocol_socket}${ip}:${port_socket}/workspace-mse`;
        let is_disconected = false; // Declarar variable local

        vm.media_buffer.Buffer[vm.stream] = null;
        vm.media_buffer.Buffer[vm.stream] = vm.media_buffer.mediaSource.addSourceBuffer(mime);
        vm.media_buffer.Buffer[vm.stream].mode = 'sequence';

        vm.media_buffer.updateend_listener = function (e) {
          if (vm.media_buffer.mediaSource.duration !== Number.POSITIVE_INFINITY &&
            video.currentTime === 0 &&
            vm.media_buffer.mediaSource.duration > 0) {
            video.currentTime = vm.media_buffer.mediaSource.duration;
            vm.media_buffer.mediaSource.duration = Number.POSITIVE_INFINITY;
          }
          video.play();
        };

        vm.media_buffer.Buffer[vm.stream].addEventListener('updateend', vm.media_buffer.updateend_listener);

        vm.media_buffer.socket = io(url, { transports: ['websocket'] });
        vm.media_buffer.socket.emit('message', {
          deviceId: vm.stream,
          command: "start-streaming"
        });

        // Usar $on para EventBus
        EventBus.$on('streamHD', vm.media_buffer.streamHD_listener = function (data1) {
          if (data1.init) {
            var data = new Uint8Array(data1.init);
            vm.media_buffer.Buffer[vm.stream].appendBuffer(data);
            data = null; // Liberar memoria
          }
          if (data1.emitSegment && init) {
            var data = new Uint8Array(data1.emitSegment.segment);
            vm.media_buffer.Buffer[vm.stream].appendBuffer(data);
            data = null; // Liberar memoria
          }
        });

        vm.media_buffer.socket.on('connect', () => {
          if (is_disconected) {
            is_disconected = false;
            vm.media_buffer.socket.emit('message', {
              deviceId: vm.stream,
              command: "start-streaming"
            });
          }
        });

        vm.media_buffer.socket.on("disconnect", (reason) => {
          is_disconected = true;
          const timer = setTimeout(() => {
            if (vm.media_buffer && vm.media_buffer.socket) {
              vm.media_buffer.socket.connect();
            }
            clearTimeout(timer);
          }, 5000 + 2);
        });

        vm.startBufferCleanup();

        // Liberar variables locales después de configurar la conexión WebSocket
        url = null;
        video = null;
        is_disconected = null;
      };

      vm.media_buffer.mediaSource.addEventListener('sourceopen', vm.media_buffer.sourceopen_listener);

      // Liberar variables locales de la función principal
      mime = null;
      vm = null;
    },

    clear_media_buffer() {
      this.stopBufferCleanup();
      if (this.media_buffer) {
        // Revocar URL del video
        if (this.media_buffer.videoUrl) {
          URL.revokeObjectURL(this.media_buffer.videoUrl);
          this.media_buffer.videoUrl = null;
        }

        // Limpiar el elemento de video
        const video = document.getElementById('video_media' + this.stream + this.ID_ref);
        if (video) {
          video.pause();
          video.src = '';
          video.load();
        }

        // Desconectar socket y limpiar referencias
        if (this.media_buffer.socket) {
          this.media_buffer.socket.disconnect();
          this.media_buffer.socket = null;
        }

        // Remover event listeners
        for (let it in this.media_buffer) {
          let listener = it.split("_")[0];
          if (it.includes("listener")) {
            if (this.media_buffer.list_media.includes(it)) {
              this.media_buffer.mediaSource.removeEventListener(listener, this.media_buffer[it]);
              this.media_buffer[it] = null; // Liberar referencia al listener
            }
            if (this.media_buffer.list_buffer.includes(it) && this.stream && this.media_buffer.Buffer && this.media_buffer.Buffer[this.stream]) {
              this.media_buffer.Buffer[this.stream].removeEventListener(listener, this.media_buffer[it]);
              this.media_buffer[it] = null; // Liberar referencia al listener
            }
          }
        }

        // Limpiar buffers
        if (this.media_buffer.Buffer && this.media_buffer.Buffer[this.stream]) {
          const sb = this.media_buffer.Buffer[this.stream];
          const cleanBuffer = () => {
            if (sb.buffered && sb.buffered.length) {
              for (let i = 0; i < sb.buffered.length; i++) {
                sb.remove(sb.buffered.start(i), sb.buffered.end(i));
              }
            }
            this.media_buffer.mediaSource.removeSourceBuffer(sb);
          };
          if (sb.updating) {
            sb.addEventListener('updateend', cleanBuffer, { once: true });
          } else {
            cleanBuffer();
          }
          this.media_buffer.Buffer[this.stream] = null;
        }

        // Eliminar listener de streamHD
        if (this.media_buffer.streamHD_listener) {
          EventBus.$off('streamHD', this.media_buffer.streamHD_listener);
          this.media_buffer.streamHD_listener = null;
        }

        // Limpiar MediaSource
        if (this.media_buffer.mediaSource) {
          this.media_buffer.mediaSource = null;
        }

        // Limpiar arrays de listeners
        this.media_buffer.list_media = null;
        this.media_buffer.list_buffer = null;

        // Limpiar objeto completo
        this.media_buffer = null;
      }
    },

    cleanupVideoResources() {
      if (this.videoElement) {
        this.videoElement.pause();
        this.videoElement.src = '';
        this.videoElement.load();
      }
      if (this.player) {
        this.player.dispose();
      }
    },

    addTimer(timer) {
      this.timers.push(timer);
    },

    cleanup() {
      // Cancelar renderizado pendiente
      this.cancelPendingRender();

      // Limpiar Intersection Observer
      this.cleanupIntersectionObserver();

      // Limpiar todos los event listeners
      this.removeAllEventListeners();

      // Limpiar event bus
      if (this.bus) {
        for (let eventName in this.bus) {
          if (this.bus[eventName]) {
            EventBus.$off(eventName, this.bus[eventName]);
          }
        }
        this.bus = {};
      }

      // Limpiar recursos de video
      this.cleanupVideoResources();

      // Limpiar timers
      this.timers.forEach(timer => {
        if (timer) clearTimeout(timer);
      });
      this.timers = [];

      // Limpiar socket
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }

      // Limpiar recording interval
      if (this.recording && this.recording.interval) {
        clearInterval(this.recording.interval);
        this.recording.interval = null;
      }

      // Limpiar media buffer
      this.clear_media_buffer();

      // Limpiar variables de estado
      this.isVisible = false;
      this.isRendering = false;
      this.pendingImageData = null;

      // Limpiar referencias a elementos DOM
      this.canvas = null;
      this.context = null;
      this.stream = null;
      this.event_bus = null;
      this.clear_draw = null;
      this.interval_shape = null;
      this.player = null;
      this.video_listening = null;
      this.media_buffer = null;
      this.bufferCleanupInterval = null;
      this.intersectionObserver = null;

      // Limpiar arrays y objetos
      this.list_elements = [];
      this.list_points = [];
      this.draw_points = [];
      this.selected_points = [];
      this.eventListeners = [];
      this.busListeners = {};
      this.timers = [];

      // Emitir evento de cierre
      EventBus.$emit('close_stream', this.stream);
    },

    startBufferCleanup() {
      if (this.bufferCleanupInterval) {
        clearInterval(this.bufferCleanupInterval);
      }

      this.bufferCleanupInterval = setInterval(() => {
        if (this.media_buffer && this.media_buffer.Buffer && this.media_buffer.Buffer[this.stream]) {
          const video = document.getElementById('video_media' + this.stream + this.ID_ref);
          if (video && video.buffered.length) {
            const currentBufferSize = video.buffered.end(0) - video.buffered.start(0);
            if (currentBufferSize > this.maxBufferSize) {
              try {
                this.media_buffer.Buffer[this.stream].remove(
                  0,
                  video.buffered.end(0) - this.maxBufferSize
                );
              } catch (e) {
                console.warn('Error cleaning buffer:', e);
              }
            }
          }
        }
      }, 10000); // Limpiar cada 10 segundos
    },

    stopBufferCleanup() {
      if (this.bufferCleanupInterval) {
        clearInterval(this.bufferCleanupInterval);
        this.bufferCleanupInterval = null;
      }
    },

    // Método para procesar imagen con throttling basado en requestAnimationFrame
    scheduleImageRender(imageData) {
      // Si el componente no está visible, no procesar imágenes
      if (!this.isVisible) {
        return;
      }

      // Verificar que img existe antes de procesar
      if (!imageData.img) {
        console.warn('Image element is null, skipping render');
        return;
      }

      // Guardar la imagen más reciente
      this.pendingImageData = imageData;

      // Si ya hay un frame programado, no hacer nada
      if (this.animationFrameId) {
        return;
      }

      // Programar el renderizado para el siguiente frame
      this.animationFrameId = requestAnimationFrame(() => {
        this.renderPendingImage();
      });
    },

    // Método para renderizar la imagen pendiente
    renderPendingImage() {
      if (!this.pendingImageData) {
        this.animationFrameId = null;
        return;
      }

      const { msg, img, time } = this.pendingImageData;

      // Verificar que img existe antes de procesar
      if (!img) {
        console.warn('Image element is null, skipping render');
        this.pendingImageData = null;
        this.animationFrameId = null;
        return;
      }

      try {
        // Limpiar URL anterior si existe
        if (img.src && img.src.startsWith('blob:')) {
          URL.revokeObjectURL(img.src);
        }

        const base64Image = this.normalizeBase64ImagePayload(msg && msg.message);
        if (!base64Image) {
          console.warn('Invalid image payload received, skipping render', {
            channel: msg && msg.channel,
            messageType: typeof (msg && msg.message),
            messageLength: msg && msg.message ? String(msg.message).length : 0,
            preview: msg && msg.message ? String(msg.message).slice(0, 50) : '',
          });
          return;
        }

        // Convertir base64 a binario
        let binary = atob(base64Image);
        const len = binary.length;
        let bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binary.charCodeAt(i);
        }

        // Crear blob y asignar a imagen
        const blob = new Blob([bytes], { type: 'image/jpeg' });
        img.src = URL.createObjectURL(blob);

        // Liberar memoria explícitamente
        binary = null;
        bytes = null;

        // Actualizar FPS
        this.fps_sreaming = msg.fps;

      } catch (error) {
        console.error('Error rendering image:', error);
      }

      // Limpiar datos pendientes y frame ID
      this.pendingImageData = null;
      this.animationFrameId = null;
    },

    normalizeBase64ImagePayload(message) {
      if (message === null || message === undefined) {
        return '';
      }

      let payload = String(message).trim();
      if (!payload) {
        return '';
      }

      if (payload.startsWith('data:') && payload.includes(',')) {
        payload = payload.split(',').pop();
      }

      payload = payload
        .replace(/\s/g, '')
        .replace(/-/g, '+')
        .replace(/_/g, '/');

      const remainder = payload.length % 4;
      if (remainder === 1) {
        return '';
      }

      if (remainder > 0) {
        payload += '='.repeat(4 - remainder);
      }

      return /^[A-Za-z0-9+/]+={0,2}$/.test(payload) ? payload : '';
    },

    // Método para cancelar el renderizado pendiente
    cancelPendingRender() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
      this.pendingImageData = null;
    },

    // Método para configurar Intersection Observer
    setupIntersectionObserver() {
      if (!this.$refs['height' + this.layout_id]) {
        return;
      }

      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;

            // Si el componente no está visible, cancelar renderizado pendiente
            if (!this.isVisible) {
              this.cancelPendingRender();
            }
          });
        },
        {
          threshold: 0.1, // El componente se considera visible si al menos 10% está en viewport
          rootMargin: '50px' // Margen adicional para detectar cuando se acerca
        }
      );

      this.intersectionObserver.observe(this.$refs['height' + this.layout_id].$el);
    },

    // Método para limpiar Intersection Observer
    cleanupIntersectionObserver() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
    },

  }, // methods

  mounted() {
    // Esperar a que el DOM esté completamente renderizado
    this.$nextTick(() => {
      // Verificar que los elementos necesarios existen
      const content = document.getElementById('content' + this.stream + this.ID_ref);
      const img = document.getElementById('img' + this.stream + this.ID_ref);
      const roi = document.getElementById('drawData' + this.stream + this.ID_ref);

      if (!content || !img || !roi) {
        console.warn('Required DOM elements not found on mount, retrying...');
        // Reintentar después de un breve delay
        setTimeout(() => {
          this.mounted();
        }, 100);
        return;
      }

      // Inicializar el componente
      this.render_bus();

      // Configurar el observer de intersección
      this.setupIntersectionObserver();

      // Iniciar el buffer cleanup
      this.startBufferCleanup();

      // Observar cambios de tamaño del <img> para re-renderizar las ROIs
      // una vez que el layout definitivo esté disponible (fix blur en F5)
      if (typeof ResizeObserver !== 'undefined') {
        this._roiLastSize = { w: 0, h: 0 };
        this._roiResizeTimer = null;
        this._roiResizeObserver = new ResizeObserver(() => {
          if (this._roiResizeTimer) {
            clearTimeout(this._roiResizeTimer);
          }
          this._roiResizeTimer = setTimeout(() => {
            const rect = img.getBoundingClientRect();
            const w = Math.round(rect.width);
            const h = Math.round(rect.height);
            if (w === 0 || h === 0) return;
            if (w === this._roiLastSize.w && h === this._roiLastSize.h) return;
            this._roiLastSize = { w, h };
            this.update_shape();
            const drawData = document.getElementById('drawData' + this.stream + this.ID_ref);
            if (drawData) {
              drawData.width = w;
              drawData.height = h;
            }
          }, 150);
        });
        this._roiResizeObserver.observe(img);
      }
    });
  },

  beforeDestroy() {
    // Limpiar todos los event listeners
    this.removeAllEventListeners();

    // Limpiar timeouts
    if (this.clear_draw) {
      clearTimeout(this.clear_draw);
      this.clear_draw = null;
    }

    if (this.timeout_connection) {
      clearTimeout(this.timeout_connection);
      this.timeout_connection = null;
    }

    // Limpiar referencias del contexto
    this.context = null;
    this.sizes_draw = null;

    // Limpiar elementos de la lista
    this.list_elements = [];

    // Limpiar el bus de eventos
    this.$Helper.clear_bus(EventBus, this.bus, 'cam_test');

    // Limpiar recursos de video
    this.cleanupVideoResources();

    // Limpiar el observer de intersección
    this.cleanupIntersectionObserver();

    // Limpiar el buffer cleanup
    this.stopBufferCleanup();

    // Disconnect ROI resize observer
    if (this._roiResizeObserver) {
      this._roiResizeObserver.disconnect();
      this._roiResizeObserver = null;
    }
    if (this._roiResizeTimer) {
      clearTimeout(this._roiResizeTimer);
      this._roiResizeTimer = null;
    }
  }, // beforeDestroy
};
